import script from "./SearchesDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchesDropdown.vue?vue&type=script&setup=true&lang=js"

import "./SearchesDropdown.vue?vue&type=style&index=0&id=8e7bb2d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e7bb2d4"]])

export default __exports__